import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { TOAST_ID } from "./constants";

const baseStyle = {
  borderRadius: "12px",
  background: "#FAEAF6",
  color: "#041122",
  border: "1px solid #E5E7EB",
  fontSize: "14px",
  fontWeight: "500",
};

export const showSuccess = (msg) =>
  toast.success(msg, {
    id: TOAST_ID,
    style: {
      ...baseStyle,
      borderLeft: "4px solid #16A34A",
    },
    iconTheme: {
      primary: "#16A34A",
      secondary: "#FAEAF6",
    },
  });

export const showError = (msg) =>
  toast.error(msg, {
    id: TOAST_ID,

    style: {
      ...baseStyle,
      borderLeft: "4px solid #DC2626",
    },
    iconTheme: {
      primary: "#DC2626",
      secondary: "#FAEAF6",
    },
  });

export const confirmAction = async ({
  title = "Are you sure?",
  text = "",
  confirmText = "Yes",
  cancelText = "Cancel",
  icon = "warning",
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,

    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,

    reverseButtons: true,
    focusCancel: true,
    scrollbarPadding: false,
    buttonsStyling: false,

    background: "#FFF7F4",
    color: "#381700",
    iconColor: "#D4AF37",

    customClass: {
      popup: "px-3",
      title: "text-lg font-semibold text-primaryText",
      htmlContainer: "text-sm text-secondaryText leading-relaxed",

      confirmButton:
        "px-6 py-2.5 bg-btnColor text-white font-semibold mx-2 hover:bg-btnHoverColor transition",

      cancelButton:
        "px-6 py-2.5 bg-[#F7BFAD] text-[#381700] font-semibold mx-2 hover:opacity-90",
    },
  });

  return result.isConfirmed;
};

export const confirmThreeWayAction = async ({
  title = "Are you sure?",
  text = "",
  icon = "warning",

  confirmText = "Confirm",
  denyText = "Secondary",
  cancelText = "Cancel",
  extraText = null,
}) => {
  let extraClicked = false;

  const result = await Swal.fire({
    title,
    text,
    icon,

    showCancelButton: true,
    showDenyButton: true,

    confirmButtonText: confirmText,
    denyButtonText: denyText,
    cancelButtonText: cancelText,

    reverseButtons: true,
    focusCancel: true,
    scrollbarPadding: false,
    buttonsStyling: false,

    background: "#FFF8E6",
    color: "#1F2937",
    iconColor: "#D4AF37",

    html: `
      <div class="text-xs text-secondaryText mb-3">${text}</div>
      ${extraText
        ? `<button id="swal-extra-btn" 
               class="px-4 py-2 rounded-xl text-sm bg-danger text-white font-semibold mx-2 hover:opacity-90 transition">
               ${extraText}
             </button>`
        : ""
      }
    `,

    didOpen: () => {
      if (extraText) {
        const btn = document.getElementById("swal-extra-btn");
        if (btn) {
          btn.addEventListener("click", () => {
            extraClicked = true;
            Swal.close();
          });
        }
      }
    },

    customClass: {
      popup: "rounded-2xl px-3",
      title: "text-lg font-semibold text-primaryText",
      htmlContainer: "text-xs text-secondaryText",

      confirmButton:
        "px-4 py-2 rounded-xl text-sm bg-btnColor text-white font-semibold mx-2 hover:bg-btnHoverColor transition",

      denyButton:
        "px-4 py-2 rounded-xl text-sm bg-[#F7BFAD] text-[#381700] font-semibold mx-2 hover:opacity-90 transition",

      cancelButton:
        "px-4 py-2 rounded-xl text-sm bg-gray-100 text-gray-700 font-semibold mx-2 hover:opacity-90 transition",
    },
  });

  if (extraClicked) return "extra";
  if (result.isConfirmed) return "confirm";
  if (result.isDenied) return "deny";
  return "cancel";
};